import {WB_AttributeTypeRow, WB_EntityAttributeTypeRow, WB_EntityRow} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import * as _ from "lodash";
import {
    esWB_AttributeType,
    esWB_Customer,
    esWB_Entity,
    esWB_Entity_AttributeType,
    esWB_Finished_Product, esWB_Period, esWB_Product_Group
} from "../PA.Core/PAdbSchema";
import {ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";


export class EntityTypeUtils {

    private static dctEntityTypeByWbId: { [id: number]: WB_EntityRow } = {}
    private static dbContext: PAdbContext

    private static dctCustomAttributeTypesByMDSDimension: { [wbMDSetId: number]: { [dim: string]: WB_AttributeTypeRow[] } } = {}
    private static dctCustomAttributeTypesByWbId: { [wbEntityId: number]: WB_AttributeTypeRow[] } = {}
    private static dctCoreAttributeTypesByDimension: { [dim: string]: WB_AttributeTypeRow[] } = {}

    private static getDbContext(): PAdbContext {
        if (!_.isEmpty(EntityTypeUtils.dbContext))
            return EntityTypeUtils.dbContext

        EntityTypeUtils.dbContext = new PAdbContext()
        return EntityTypeUtils.dbContext
    }

    static async getEntityTypeRow(wbEntityId: number): Promise<WB_EntityRow> {

        if (wbEntityId in EntityTypeUtils.dctEntityTypeByWbId) {
            return EntityTypeUtils.dctEntityTypeByWbId[wbEntityId]
        }
        if (!(+wbEntityId > 0))
            return undefined

        let ctx = EntityTypeUtils.getDbContext()
        let row = <WB_EntityRow>await ctx.find(esWB_Entity, +wbEntityId)

        if (_.isEmpty(row))
            return undefined

        EntityTypeUtils.dctEntityTypeByWbId[wbEntityId] = row
        return row
    }

    static async getEntityTypeRows(wbEntityIds: number[]): Promise<{ [id: number]: WB_EntityRow }> {
        let rvs: { [id: number]: WB_EntityRow } = {}
        let wbEntityIdsToLoad: number[] = []
        for (let wbEntityId of wbEntityIds) {
            if (wbEntityId in EntityTypeUtils.dctEntityTypeByWbId) {
                rvs[wbEntityId] = EntityTypeUtils.dctEntityTypeByWbId[wbEntityId]
            } else {
                if (!(+wbEntityId > 0)) {
                    rvs[wbEntityId] = undefined
                } else {
                    wbEntityIdsToLoad.push(wbEntityId)
                }
            }
        }


        let ctx = EntityTypeUtils.getDbContext()
        let rows = <WB_EntityRow[]>await ctx.findAll(esWB_Entity, {
            where: {
                DELETED_IND: {neq: '1'},
                WB_ENTITY_ID: {inq: wbEntityIdsToLoad}
            }
        })

        for (let row of rows) {
            rvs[row.cif.WB_ENTITY_ID] = row
            EntityTypeUtils.dctEntityTypeByWbId[row.cif.WB_ENTITY_ID] = row
        }

        return rvs

    }

    static async getEntityTypeRowByMeta(metaType: string, metaWbId: number): Promise<WB_EntityRow> {
        for (let wbEntity in EntityTypeUtils.dctEntityTypeByWbId) {
            let row = EntityTypeUtils.dctEntityTypeByWbId[wbEntity]
            if ((row.cif.META_TYPE == metaType) && (row.cif.META_WB_ID == metaWbId))
                return row
        }

        let ctx = EntityTypeUtils.getDbContext()
        let rows = <WB_EntityRow[]>await ctx.findAll(esWB_Entity, {
            where: {
                META_TYPE: metaType,
                META_WB_ID: metaWbId,
                DELETED_IND: {neq: '1'}
            }
        })

        if (_.isEmpty(rows))
            return undefined

        let row = rows[0]
        let wbEntityId = row.cif.WB_ENTITY_ID
        EntityTypeUtils.dctEntityTypeByWbId[wbEntityId] = row

        return row
    }

    static async getEntityTypeRowByLogicalKey(wbMDSetId: number, entityDimension: string, entityId: string): Promise<WB_EntityRow> {
        for (let wbEntity in EntityTypeUtils.dctEntityTypeByWbId) {
            let row = EntityTypeUtils.dctEntityTypeByWbId[wbEntity]
            if ((row.cif.WB_MDSET_ID == wbMDSetId) && (row.cif.ENTITY_DIMENSION == entityDimension) && (row.cif.ENTITY_ID == entityId))
                return row
        }

        let ctx = EntityTypeUtils.getDbContext()
        let rows = <WB_EntityRow[]>await ctx.findAll(esWB_Entity, {
            where: {
                WB_MDSET_ID: wbMDSetId,
                ENTITY_DIMENSION: entityDimension,
                ENTITY_ID: entityId,
                DELETED_IND: {neq: '1'}
            }
        })

        if (_.isEmpty(rows))
            return undefined

        let row = rows[0]
        let wbEntityId = row.cif.WB_ENTITY_ID
        EntityTypeUtils.dctEntityTypeByWbId[wbEntityId] = row

        return row
    }


    static resetAttributeCache() {
        EntityTypeUtils.dctCustomAttributeTypesByWbId = {}
        EntityTypeUtils.dctCustomAttributeTypesByMDSDimension = {}
        EntityTypeUtils.dctCoreAttributeTypesByDimension = {}
    }


    static async getEntityAttributeTypes(wbEntityTypeId: number, bIncludeCore?: boolean): Promise<WB_AttributeTypeRow[]> {

        let rv: WB_AttributeTypeRow[] = []
        if (wbEntityTypeId in EntityTypeUtils.dctCustomAttributeTypesByWbId) {
            rv = _.clone(EntityTypeUtils.dctCustomAttributeTypesByWbId[wbEntityTypeId])
        } else {
            let ctx = EntityTypeUtils.getDbContext()
            let rr = new ESRecordResolver(ctx, {})
            let attribRels = <WB_EntityAttributeTypeRow[]>await rr.queryAllWithRelationships(esWB_Entity_AttributeType, {
                where: {
                    WB_ENTITY_ID: wbEntityTypeId,
                    DELETED_IND: {neq: '1'}
                }
            })
            let dct: { [id: number]: WB_AttributeTypeRow } = {}
            _.forEach(attribRels, (a) => {
                if (_.isEmpty(a.WB_AttributeTypeRow))
                    return
                let wbAttributeMId = a.WB_AttributeTypeRow.cif.WB_ATTRIBUTEM_ID
                if (!(wbAttributeMId in dct))
                    dct[wbAttributeMId] = a.WB_AttributeTypeRow
            })
            EntityTypeUtils.dctCustomAttributeTypesByWbId[wbEntityTypeId] = _.values(dct)
            rv = _.clone(EntityTypeUtils.dctCustomAttributeTypesByWbId[wbEntityTypeId])
        }

        if (bIncludeCore) {
            let eType = await EntityTypeUtils.getEntityTypeRow(wbEntityTypeId)
            if (!_.isEmpty(eType)) {
                let coreAttr = await EntityTypeUtils.getCoreAttributeTypes(eType.cif.ENTITY_DIMENSION)
                if (coreAttr.length)
                    rv.push.apply(rv, coreAttr)
            }
        }

        return rv
    }

    static async getCustomAttributeTypes(wbMDSetId: number, dimensionId: string): Promise<WB_AttributeTypeRow[]> {

        let rv: WB_AttributeTypeRow[] = []
        if (_.isEmpty(dimensionId) || (!(wbMDSetId > 0)))
            return []

        if (!(wbMDSetId in EntityTypeUtils.dctCustomAttributeTypesByMDSDimension))
            EntityTypeUtils.dctCustomAttributeTypesByMDSDimension[wbMDSetId] = {}

        if (dimensionId in EntityTypeUtils.dctCustomAttributeTypesByMDSDimension[wbMDSetId]) {
            rv = _.clone(EntityTypeUtils.dctCustomAttributeTypesByMDSDimension[wbMDSetId][dimensionId])
        } else {

            let ctx = EntityTypeUtils.getDbContext()
            rv = await ctx.findAll(esWB_AttributeType, {
                where: {
                    WB_MDSET_ID: wbMDSetId,
                    ENTITY_DIMENSION: dimensionId,
                    DELETED_IND: {neq: '1'}
                }
            })

            EntityTypeUtils.dctCustomAttributeTypesByMDSDimension[wbMDSetId][dimensionId] = _.clone(rv)

        }

        return rv;
    }

    static async getCoreAttributeTypes(entityDimension: string): Promise<WB_AttributeTypeRow[]> {

        let rv: WB_AttributeTypeRow[] = []
        if (!(entityDimension in EntityTypeUtils.dctCoreAttributeTypesByDimension)) {
            let ctx = EntityTypeUtils.getDbContext()
            let coreAttrs: WB_AttributeTypeRow[] = <WB_AttributeTypeRow[]>await ctx.findAll(esWB_AttributeType, {
                where: {
                    WB_MDSET_ID: {inq: [0]},
                    ENTITY_DIMENSION: entityDimension,
                    CORE_IND: '1',
                    DELETED_IND: {neq: '1'}
                }
            })
            EntityTypeUtils.dctCoreAttributeTypesByDimension[entityDimension] = coreAttrs
        }

        rv = _.clone(EntityTypeUtils.dctCoreAttributeTypesByDimension[entityDimension] || [])

        return rv
    }

    static async getAttributeType(wbAttributeMId: number): Promise<WB_AttributeTypeRow> {
        let ctx = EntityTypeUtils.getDbContext()
        if (!(wbAttributeMId > 0))
            return undefined

        let rv = <WB_AttributeTypeRow[]>await ctx.findUsingCache(esWB_AttributeType, [wbAttributeMId])
        return _.first(rv)

    }



    static async getStorageMapper(wbEntityId: number): Promise<string> {
        let et = await EntityTypeUtils.getEntityTypeRow(wbEntityId)
        switch (et?.cif?.SET_TYPE) {
            case "Customer":
            case "Vendor":
                return esWB_Customer
            case "Product":
                return esWB_Finished_Product
            case "ProductGroup":
                return esWB_Product_Group

            case "Period":
        }
        return esWB_Period
        return ""
    }


}